/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../../context";

const ProtectedRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const {
    state: { user },
  } = useAuth();
  const { pathname } = useLocation();

  const permissionLevel = user?.userSecurities[0] || "user";
  const employeeNumber = user?.employeeNumber?.trim();
  
  // Special employee numbers that should have access to all followups
  const specialFollowupAccess = ["9098", "11101"];
  const hasSpecialFollowupAccess = specialFollowupAccess.includes(employeeNumber);
  
  const checkPermissions = () => {
    if (allowedRoles.includes(permissionLevel)) {
      return true;
    }
    
    // Allow special employee numbers access to allUsersFollowups route
    if (pathname.includes("allUsersFollowups") && hasSpecialFollowupAccess) {
      return true;
    }
    
    // user level permissions can only access their own baseball card
    if (
      permissionLevel === "user" &&
      pathname.includes("baseball-card") &&
      user.employeeNumber === pathname.split("/").at(-1)
    ) {
      return true;
    }
    return false;
  };

  const isAuth = checkPermissions();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default ProtectedRoute;

ProtectedRoute.propTypes = {
  component: PropTypes.any.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};
